import React from 'react'

// Illustration for the "Card" row style.
// The background, border and shadow are applied to each column instead of the
// row, so every column becomes its own panel. We draw two separate boxes.
export default function IconContainerStyleCard({ ...rest }) {
    return (
        <svg width='56' height='36' viewBox='0 0 56 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            {/* one panel per column */}
            <rect x='0.5' y='0.5' width='25' height='35' rx='4' fill='#EEEEED' stroke='#E1E1E0' />
            <rect x='30.5' y='0.5' width='25' height='35' rx='4' fill='#EEEEED' stroke='#E1E1E0' />
            {/* left column content */}
            <rect x='5.5' y='12' width='15' height='3' rx='1.5' fill='#C4C4C1' />
            <rect x='5.5' y='18' width='15' height='2' rx='1' fill='#D6D6D4' />
            <rect x='5.5' y='22' width='10' height='2' rx='1' fill='#D6D6D4' />
            {/* right column content */}
            <rect x='35.5' y='12' width='15' height='3' rx='1.5' fill='#C4C4C1' />
            <rect x='35.5' y='18' width='15' height='2' rx='1' fill='#D6D6D4' />
            <rect x='35.5' y='22' width='10' height='2' rx='1' fill='#D6D6D4' />
        </svg>
    )
}
